import {
  FunctionComponent,
  PropsWithChildren,
  StrictMode,
  useMemo,
} from "react";
import { BrowserRouter } from "react-router-dom";
import { PreferencesContext } from "./PreferencesContext";
import { Mount } from "@app/components/Mount";
import { AuthContextProvider } from "./AuthContext";
import { ApiDispatcher } from "@app/backendApi/apiDispatcher";
import { ApiDispatchProvider } from "./ApiDispatch";

export const AppContext: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const apiDispatcher = useMemo(() => new ApiDispatcher(), []);

  return (
    <StrictMode>
      <ApiDispatchProvider value={apiDispatcher}>
        <AuthContextProvider>
          <PreferencesContext>
            <BrowserRouter>
              <Mount>{children}</Mount>
            </BrowserRouter>
          </PreferencesContext>
        </AuthContextProvider>
      </ApiDispatchProvider>
    </StrictMode>
  );
};
